import { render } from "./ResultsParticipantRouter.vue?vue&type=template&id=3de69979"
import script from "./ResultsParticipantRouter.vue?vue&type=script&lang=js"
export * from "./ResultsParticipantRouter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__